'use strict';

import _ from 'underscore';
import $ from 'jquery';
import logger from 'loglevel';

import { Store } from './stores/Store';
import { EntryPoint } from './entryPoints/EntryPoint';

import components from './components/index';
import {ARROW_CONFIG} from './config/index';
import * as entryPoints from './entryPoints/index';
import flags, { FeatureFlag } from './utilities/featureFlags';
import {Globalisation} from './utilities/Globalisation';
import mediator from './mediator';

import './index.scss';

const $global = require('../assets/js/globalElements');
const $body = $global.$body;

let uikit = {
  config: ARROW_CONFIG,
  globalisation: new Globalisation(),
  logger: logger,
  mediator: mediator,
  featureFlags: flags,
  FeatureFlag: FeatureFlag,
  Store: Store,
  EntryPoint: EntryPoint,
  components: components,
  vendor: require('./utilities/vendor'),
  entryPoints: {},
  initialize: function initializeUiKit() {
    // Initialize the entry points
    entryPoints.initialize(this.entryPoints);

    $(function onDocumentReady() {
      components.createWithPriority($body);
    });

    mediator.on(ARROW_CONFIG.events.ui.ajaxContentLoaded, ($parent) => {
      components.createAjaxWithPriority($parent);
    });

    mediator.on(ARROW_CONFIG.events.ui.sitecorePlaceholderLoaded, ($parent) => {
      components.createSitecoreWithPriority($parent);
    });

  },

  registerEntryPoints: function(entryPoints) {
    // Add to our list of entry points
    _.extend(this.entryPoints, entryPoints);

    // Loop each entry point and register
    _.each(entryPoints, (entryPoint) => {
      if (entryPoint.shouldRegister()) {
        entryPoint.register();
        entryPoint.isRegistered = true;
      }
    });
  }
};

// We will use a global variable to commincate to the outside world for the moment
// so we don't need another dependency manager like AMD
window.Arrow = window.Arrow || {};
window.Arrow.uikit = uikit;
window.Arrow.mediator = mediator;




// WEBPACK FOOTER //
// ./uikit/index.js